import { createFileRoute } from "@tanstack/react-router";

import PersonEditPage from "/src/routes/person/edit";

export const Route = createFileRoute("/_main/person/$id/edit")({
  component: PersonEditPage,
});
